export default __webpack_public_path__ + "549b811fb0ffb1eb84c8904da61b81af.png";